import { parse } from 'graphql';

import { createAuthenticatedGraphQLClient } from '../auth/createAuthenticatedGraphQLClient';
import type { RuntimeEnvironment } from '../graphql/config/runtimeConfig';
import type {
  ReplayDoorVisitMutation,
  ReplayDoorVisitMutationVariables,
} from '../graphql/queries/replayDoorVisit.generated';

export type ReplayDoorVisitClientOverrides = {
  env: RuntimeEnvironment;
  fetchImpl?: Parameters<typeof createAuthenticatedGraphQLClient>[0]['fetchImpl'];
};

// Keep this selection set in sync with replayDoorVisit.graphql. Codegen emits
// operation types only, so this is the authenticated Field Ops document sent at runtime.
export const REPLAY_DOOR_VISIT_MUTATION = parse(/* GraphQL */ `
  mutation ReplayDoorVisit($doorVisitId: Int!, $requestId: ID!) {
    replayDoorVisit(doorVisitId: $doorVisitId, requestId: $requestId) {
      doorVisitId
    }
  }
`);

export const replayDoorVisit = async (
  doorVisitId: number,
  requestId: string,
  overrides: ReplayDoorVisitClientOverrides,
): Promise<number> => {
  const client = createAuthenticatedGraphQLClient(overrides);
  const variables: ReplayDoorVisitMutationVariables = { doorVisitId, requestId };
  const result = await client.request<ReplayDoorVisitMutation>({
    document: REPLAY_DOOR_VISIT_MUTATION,
    variables,
  });

  return result.replayDoorVisit.doorVisitId;
};
